import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../Home/Header";
import './AppHome.css';
import '../Admin/Admin.css';
import { MdVisibility, MdEdit, MdDelete } from 'react-icons/md';
import DialogBox from "../Home/DialogBox";



const API = "https://gym-invoice-back.onrender.com/api/categories";

export default function CategoryActivityManager() {
  const [categories, setCategories] = useState([]);

  // Category form
  const [categoryName, setCategoryName] = useState("");

  // Activity form
  const [name, setActivityName] = useState("");
  const [activityCount, setActivityCount] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const navigate = useNavigate();

  // Editing states
  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [editingActivity, setEditingActivity] = useState(null);
    const [dialog, setDialog] = useState({
      show: false,
      type: "",
      title: "",
      message: "",
      onConfirm: null,
    });

       useEffect(() => {
              const role = sessionStorage.getItem("userRole");
              if (!role) navigate("/");
            }, [navigate]);

  // -----------------------
  // LOAD ALL CATEGORIES
  // -----------------------
  const loadCategories = async () => {
    const res = await axios.get(API);
    setCategories(res.data);
  };

  useEffect(() => {
    loadCategories();
  }, []);

  // -----------------------
  // ADD CATEGORY
  // -----------------------
  const addCategory = async () => {
    if (!categoryName.trim()) return alert("Enter a category name");

    await axios.post(API, {
      name: categoryName,
      activities: []
    });

    setCategoryName("");
    loadCategories();
  };

  // -----------------------
  // UPDATE CATEGORY
  // -----------------------
  const updateCategory = async (id) => {
    if (!categoryName.trim()) return alert("Enter category name");

    await axios.put(`${API}/${id}`, {
      id: id,
      name: categoryName
    });

    setEditingCategoryId(null);
    setCategoryName("");
    loadCategories();
  };

  // -----------------------
  // DELETE CATEGORY
  // -----------------------
  const deleteCategory = async (id) => {
    await axios.delete(`${API}/${id}`);
    loadCategories();
  };

  // -----------------------
  // ADD ACTIVITY
  // -----------------------
  const addActivity = async () => {
    if (!selectedCategoryId || !name.trim() || !activityCount.trim()) {
      return alert("Fill all activity fields");
    }

    await axios.post(`${API}/${selectedCategoryId}/activities`, {
      name: name,
      count: activityCount


    });

    setActivityName("");
    setActivityCount("");
    loadCategories();
  };

  // -----------------------
  // UPDATE ACTIVITY
  // -----------------------
  const updateActivity = async () => {
    const { categoryId, activityId } = editingActivity;

    await axios.put(`${API}/${categoryId}/activities`, {
      id: activityId,
      name: name,
      count: Number(activityCount)
    });

    setEditingActivity(null);
    setActivityName("");
    setActivityCount("");
    loadCategories();
  };

  // -----------------------
  // DELETE ACTIVITY
  // -----------------------
  const deleteActivity = async (categoryId, activityId) => {
    await axios.delete(`${API}/${categoryId}/activities/${activityId}`);
    loadCategories();
  };

  // -----------------------
  // RENDER UI
  // -----------------------
  return (
     <div className="dashboard">

              <Header />
    <div className="payment-container">
      <h2>Category & Activity Manager</h2>

      {/* CATEGORY FORM */}
       <div className="payment-card">
        <h3>Add / Edit Category</h3>

        <input
          type="text"
          placeholder="Category Name"
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
        />

     <div className="filter-buttons">
       {editingCategoryId ? (
         <>
           <button
             className="pay-button"
             onClick={() => updateCategory(editingCategoryId)}
           >
             Update Category
           </button>

           {/* CANCEL BUTTON */}
           <button
             className="pay-button"
             onClick={() => {
               setEditingCategoryId(null);
               setCategoryName(""); // clear input
             }}
             style={{ marginLeft: "10px" }}
           >
             Cancel
           </button>
         </>
       ) : (
         <button className="pay-button" onClick={addCategory}>
           Add Category
         </button>
       )}
     </div>

      </div>

      {/* ACTIVITY FORM */}
      <div className="payment-card">
        <h3>Add / Edit Activity</h3>

        <select
          value={selectedCategoryId}
          onChange={(e) => setSelectedCategoryId(e.target.value)}
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          placeholder="Activity Name"
          value={name}
          onChange={(e) => setActivityName(e.target.value)}
        />

        <input
          type="text"
          placeholder="Count"
          value={activityCount}
          onChange={(e) => setActivityCount(e.target.value)}

        />
       <div className="filter-buttons">

         {editingActivity ? (
           <>
             <button className="pay-button" onClick={updateActivity}>
               Update Activity
             </button>

             {/* CANCEL BUTTON */}
             <button
               className="pay-button"
               onClick={() => {
                 setEditingActivity(null);        // exit edit mode
                 setActivityName("");             // clear fields
                 setActivityCount("");
                 setSelectedCategoryId("");       // reset dropdown (optional)
               }}
               style={{ marginLeft: "10px" }}
             >
               Cancel
             </button>
           </>
         ) : (
           <button className="pay-button" onClick={addActivity}>
             Add Activity
           </button>
         )}

       </div>

      </div>
       </div>

     <div className="payment-table">
      <h3 style={{ marginTop: 30 }}>All Categories & Activities</h3>

      {categories.length === 0 ? (
        <p>No categories added yet.</p>
      ) : (
        <table border="1" width="100%" cellPadding="10">
          <thead>
            <tr>
              <th>Category</th>
              <th>Activities</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {categories.map((cat) => (
              <tr key={cat.id}>
                <td>{cat.name}</td>

                <td>
                  {cat.activities.length === 0 ? (
                    <i>No activities</i>
                  ) : (
                    <ul>
                      {cat.activities.map((act) => (
                        <li key={act.id}>
                          {act.name} — {act.count}

                          <div className="table-action-buttons">
                          <button className="action-btn edit-btn"
                            style={{ marginLeft: 10 }}
                            onClick={() => {
                              setEditingActivity({
                                categoryId: cat.id,
                                activityId: act.id,
                              });
                              setActivityName(act.name);
                              setActivityCount(act.count);
                              setSelectedCategoryId(cat.id);
                            }}
                          >
                           <MdEdit size={20} />
                          </button>
                          <button
                            className="action-btn delete-btn"
                            onClick={() => {
                              setDialog({
                                show: true,
                                type: "confirm",
                                title: "Delete Activity",
                                message: `Delete "${act.name}"?`,
                                onConfirm: () => deleteActivity(cat.id, act.id)
                              });
                            }}
                          >
                            <MdDelete size={20}/>
                          </button>

                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </td>

                <td>
                <div className="table-action-buttons">
                  <button className="action-btn edit-btn"
                    onClick={() => {
                      setEditingCategoryId(cat.id);
                      setCategoryName(cat.name);
                    }}
                  >
                    <MdEdit size={20}/> Edit
                  </button>
                 <button
                   className="action-btn delete-btn"
                   onClick={() => {
                     setDialog({
                       show: true,
                       type: "confirm",
                       title: "Confirm Delete",
                       message: `Delete Category "${cat.name}"?`,
                       onConfirm: () => deleteCategory(cat.id)
                     });
                   }}
                 >
                   <MdDelete size={20}/> Delete
                 </button>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
     </div>
  );
}
